import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import {
  click,
  icon,
  origins,
  redo,
  textType,
  typed,
  undo,
} from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { Dispatch } from 'redux'
import { HistoryChangeDetails, HistoryInteractionType } from './types'

export const sendHistoryUndoRedoClickEvent = (
  isUndo: boolean,
  dispatch: Dispatch,
  isKeyboardEvent: boolean,
  changeDetails?: HistoryChangeDetails
) => {
  const name = isUndo ? undo : redo
  const eventType = isKeyboardEvent ? textType : icon
  const interactionType = isKeyboardEvent ? typed : click
  const value = changeDetails?.type
  const text = changeDetails?.action || HistoryInteractionType.MANUAL_EDIT
  const id = changeDetails?.id

  dispatch(
    userClick({
      origin: origins.undoRedoClick,
      name,
      type: eventType,
      interactionType,
      value,
      text,
      id,
    })
  )
}
